import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';

@supertypeClass({ toClient: true, toServer: true })
export class BrothersAndSisters extends Everything {
  @property()
  title: string;

  @property()
  status: string;

  @property()
  diedAt: string;

  @property()
  causeOfDeath: string;

  constructor() {
    super();
  }

  static new(title, status) {
    return new BrothersAndSisters().init(title, status);
  }

  init(title, status) {
    this.title = title || '';
    this.status = status || '';
    return this;
  }
}
